import styled from "styled-components";

export const AffiliatedWrapper = styled.div`
  padding: 24px;
  @media only screen and (max-width: 500px) {
    padding: 5px;
  }
`;

export const AffiliatedCopyMobile = styled.div`
  padding: 24px;
  background-color: ${(props) => props.theme.backgroundColor};
  margin-bottom: 15px;
  border-radius: 5px;
  p {
    margin: 10px 0;
  }
  svg {
    font-size: 1.5em;
    margin-right: 5px;
  }
`;

export const AffiliatedStepsPc = styled.div`
  display: flex;
  div {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 20px;
    span {
      padding: 5px 10px;
      border-radius: 30px;
      background-color: ${(props) => props.theme.primary};
    }
  }
  div:nth-child(2) {
    background-color: rgb(4 231 98);
    transform: skewX(-30deg);
    margin: 0 -25px;
    p,
    span {
      transform: skewX(30deg);
    }
    span {
      background-color: ${(props) => props.theme.backgroundColor};
    }
  }
  div:last-child,
  div:first-child {
    background-color: ${(props) => props.theme.backgroundColor};
    border-radius: 5px;
  }
  div:last-child {
    padding-left: 35px;
  }
  div:first-child {
    padding-right: 35px;
  }
`;

export const AffiliatedCopyPc = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 5px;
  padding: 24px 12px;
  margin: 24px 0;
  p {
    padding: 12px;
    background-color: ${(props) => props.theme.bottomColor};
    border-radius: 5px;
  }
  div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const YourSalesWrapper = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 24px;
  border-radius: 5px;
  h2 {
    margin-bottom: 24px;
  }
`;

export const MetaAwardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${(props) => props.theme.bottomColor};
  height: 100%;
  border-radius: 5px;
  padding: 24px;
`;

export const AwardBackImage = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 130px;

  svg {
    color: ${(props) => props.theme.fontColor}09;
  }
`;

export const AwardValuesContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  div {
    display: flex;
    flex-direction: column;
  }

  div:last-child {
    align-items: flex-end;
  }
`;

export const MonthlySalesContainer = styled.div`
  padding: 20px;

  border-radius: 5px;
  background-color: ${(props) => props.theme.bottomColor};

  height: 100%;
  margin: 15px 0;
  p {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  @media (min-width: 1536px) {
    margin: 0 15px;
  }
  @media only screen and (max-width: 600px) {
    text {
      font-size: 10px;
    }
  }
  @media only screen and (max-width: 375px) {
    text {
      font-size: 8px;
    }
  }
`;

export const TotalAffiliatedLevel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => props.theme.bottomColor};
  padding: 20px;
  border-radius: 5px;
  height: 100%;
  p:first-child {
    margin-bottom: 10px;
  }
`;

export const AffiliatedLevelContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  @media (min-width: 1536px) {
    gap: 0;
  }
`;

export const AffiliatedLevel = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 40%;
  align-items: center;

  @media (min-width: 600px) {
    flex-basis: 20%;
  }
  span {
    display: flex;
    svg {
      color: ${(props) => props.theme.primary};
    }
  }

  span ~ svg {
    font-size: 1.7em;
  }

  div {
    text-align: center;
    border-top: 2px solid ${(props) => props.theme.selectColor};
    span:nth-child(2) {
      color: ${(props) => props.theme.primary};
    }
    span:nth-child(3) {
      color: #ff9800;
    }
  }
`;

export const AffiliatedHistoryCont = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  margin-top: 24px;
  padding: 24px;
  border-radius: 5px;
  h2 {
    margin-bottom: 24px;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: -55px;
`;

export const FilterMobileBtn = styled.button`
  padding: 8px 10px;
  background-color: ${(props) => props.theme.backgroundColor};
  border: 2px solid ${(props) => props.theme.inputColor};
  border-radius: 5px;
  &:hover {
    background-color: ${(props) => props.theme.fontColor}10;
  }

  svg {
    font-size: 1.2rem;
  }
`;

export const ModalMobileContainer = styled.div`
  position: absolute;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalMobileContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: ${props => props.theme.backgroundColor};
  border-radius: 10px;
  h2 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    span {
      cursor: pointer;
      user-select: none;
      padding: 0px 10px;
      margin-right: 10px;
    }
  }
  p {
    margin: 8px 0;
  }
`;

export const ModalMobileBtn = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 32px;
`;
export const HistoryOptionsCont = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
`;

export const HistoryButtonsCont = styled.div`
  display: flex;
  gap: 15px;
`;

export const AffTable = styled.table`
  width: 100%;
`;

export const AffTableHead = styled.thead`
  th {
    border-bottom: 1px solid ${(props) => props.theme.topElementsColor};
    text-align: left;
    padding: 15px;
    font-weight: 300;
    color: ${(props) => props.theme.fontColor}80;
    font-size: 0.9rem;
  }

  tr th:nth-child(4) {
    text-align: left;
  }
  tr th:last-child {
    padding-left: 50px;
  }
`;

export const AffTableBody = styled.tbody`
  td {
    text-align: left;
    border-bottom: 1px solid ${(props) => props.theme.topElementsColor};
    padding: 15px;
  }
  td:last-child {
    padding-left: 50px;
  }
`;

export const AffTdStar = styled.td`
  text-align: center;
  color: ${(props) => props.theme.primary};
`;

export const FakeThead = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 18px;
  margin-bottom: 5px;

  div:last-child {
    text-align: center;
  }
`;

export const FixStarMobile = styled.div`
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.primary};
  font-size: 0.8rem;
  @media (min-width: 400px) {
    font-size: 1rem;
  }
`;

export const MobileDetailsCont = styled.div`
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    justify-content: space-between;
  }
`;
export const DashedContainer = styled.div`
  width: 100%;
  align-items: center;
  flex: 1;
  padding: 0 10px;
`;
export const DashedGuide = styled.div`
  width: 100%;
  height: 1px;
  border: 1px dashed ${(props) => props.theme.fontColor}80;
`;

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: ${(props) => props.theme.fontColor}80;
  span {
    font-size: 60px;
    margin-bottom: 10px;
    transform: rotate(90deg);
  }
`;